import {
    getObjects,
    createObjects,
    updateObjects,
    deleteObjects,
} from './../api/webApplicationApi';
import { v4 as uuidv4 } from 'uuid';

const objectType = 'bin';

export class Bin {
    private _saveMethod = createObjects;
    private _object: omBin;
    private _lastError: Error;

    public constructor(binID: string) {
        this._object = {
            binID: binID,
            accountID: undefined,
            trashes: [],
        };
    }

    public static createNew(): Bin {
        return new Bin(uuidv4());
    }

    public static createFromObject(bin: omBin): Bin {
        const obj = new Bin(bin.binID);
        obj._object = bin;
        obj._saveMethod = updateObjects;
        return obj;
    }

    public async load(): Promise<boolean> {
        const getObject: GetRequest = {
            objectType: objectType,
            keys: [this._object.binID],
        };
        this._lastError = undefined;
        try {
            const response = await getObjects([getObject]);
            if (
                response &&
                response.length > 0 &&
                response[0].objects &&
                response[0].objects.length == 1
            ) {
                this._saveMethod = updateObjects;
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('bin not found');
                return false;
            }
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async save(): Promise<boolean> {
        const saveObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;

        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }

        try {
            const response = await this._saveMethod([saveObject]);
            if (response) {
                this._saveMethod = updateObjects;
            } else {
                this._lastError = new Error('unknow server error');
            }
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async delete(): Promise<boolean> {
        const deleteObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;
        try {
            const response = await deleteObjects([deleteObject]);
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public get lastError(): Error {
        return this._lastError;
    }

    public get binID(): string {
        return this._object.binID;
    }

    public get accountID(): string {
        return this._object.accountID;
    }

    public set accountID(accountID: string) {
        this._object.accountID = accountID;
    }

    public get trashes(): omTrash[] {
        return this._object.trashes;
    }

    public addTrash(trash: omTrash): void {
        if (
            this._object.trashes.findIndex((item) => {
                return item.objectID == trash.objectID;
            }) >= 0
        )
            return;
        this._object.trashes.push(trash);
    }

    public deleteTrash(trash: omTrash): void {
        const index = this._object.trashes.findIndex((item) => {
            return item.objectID == trash.objectID;
        });
        if (index > -1) {
            this._object.trashes.splice(index, 1);
        }
    }
}
